import type { ComponentProps } from 'react';
import { Autocomplete as AutocompletePrimitive } from '@base-ui/react';

import { ComboboxContent, ComboboxList } from '@/components/ui/combobox';
import { Input } from '@/components/ui/input';

interface SuggestInputProps extends Omit<ComponentProps<'input'>, 'value' | 'defaultValue' | 'onChange'> {
  value: string;
  onChange: (value: string) => void;
  /** Values offered while typing; the field never requires picking one of them. */
  suggestions: string[];
}

/**
 * Free text with suggestions — what `SimpleSelect` is not: whatever is typed is
 * the value, and the list only offers values seen before as a shortcut. Legacy
 * builds these fields the same way (`c:autocomplete` over journey history).
 */
export function SuggestInput({ value, onChange, suggestions, ...inputProps }: SuggestInputProps) {
  return (
    <AutocompletePrimitive.Root items={suggestions} value={value} onValueChange={onChange} openOnInputClick>
      <AutocompletePrimitive.Input render={<Input {...inputProps} />} />
      {suggestions.length > 0 && (
        <ComboboxContent>
          <ComboboxList>
            {(item: string) => (
              <AutocompletePrimitive.Item
                key={item}
                value={item}
                className="relative flex w-full cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-hidden data-highlighted:bg-accent data-highlighted:text-accent-foreground">
                {item}
              </AutocompletePrimitive.Item>
            )}
          </ComboboxList>
        </ComboboxContent>
      )}
    </AutocompletePrimitive.Root>
  );
}
